<template>
    <b-form-file
            v-model="file"
            :state="Boolean(file)"
            @change="change"
            placeholder="Выберите файл"
            drop-placeholder="Перенесите файл сюда..."
    />
</template>

<script>

    export default {
        name: "FileUploader",
        props: {
            value: null
        },
        data() {
            return {
                file: null
            }
        },
        created() {
            this.$data.file = this.$props.value;
        },
        methods: {
            change(e){
                this.$emit('change', e)
            }
        },
        watch: {
            file(file) {
                this.$emit('input', file);
            }
        }
    }
</script>

<style scoped>

</style>